// Testdaten aus den Mitglieder-Ansichten heraushalten.
//
// Es gibt genau EIN Testkonto (`users/{uid}.isTestAccount === true`), mit dem
// nach einem Deploy am echten System geprueft wird - und die Termine, die es
// dabei anlegt (`events/{id}.isTestData === true`). Beides soll kein Mitglied
// zu sehen bekommen: weder in der Crew-Liste noch im Kalender, weder in einer
// Zahl auf der Uebersicht noch als Name unter einer Zusage.
//
// ── Warum das eine ANZEIGE-Regel sein darf ──────────────────────────────
// Bei den Kontaktwegen galt seit v0.22.0 das Gegenteil: Ein Schalter
// „oeffentlich" musste eine Eigenschaft der DATEN sein, weil eine
// Handynummer sonst trotz Schalter an jedem Client gelandet waere. Hier ist
// es umgekehrt vertretbar - in einem Testkonto und seinen Testterminen
// stehen keine personenbezogenen Daten, die geschuetzt werden muessten. Es
// geht darum, die Listen sauber zu halten, nicht darum, etwas geheim zu
// halten.
//
// Der Weg ueber die Rules waere ausserdem teuer erkauft: Firestore weist eine
// Abfrage komplett ab, sobald EIN Treffer nicht lesbar waere - jede
// Mitglieder- und Terminabfrage braeuchte also ein `where('isTestAccount',
// '!=', true)`, und `!=` findet Dokumente ohne das Feld gar nicht erst. Man
// muesste das Feld auf alle 67 Bestandsprofile und jeden Termin nachtragen.
// Dieselbe Ueberlegung wie bei `filterByWorkspace` im Nachbarprojekt.
//
// ── Die eine Ausnahme ───────────────────────────────────────────────────
// Das Testkonto selbst sieht seine Testdaten (sonst koennte es damit nicht
// arbeiten), und der Admin-Bereich zeigt sie ebenfalls - sonst waeren sie
// nicht mehr aufzuraeumen. Beides laeuft ueber `showTestData`.

/** Ist das ein Testkonto? */
export function isTestAccount(member) {
  return member?.isTestAccount === true;
}

/** Ist das ein Testtermin? */
export function isTestEvent(event) {
  return event?.isTestData === true;
}

/**
 * Darf dieser Betrachter Testdaten sehen?
 *
 * Die Entscheidung steht hier und nicht als Ausdruck in den beiden Hooks:
 * Genau diese eine Zeile entscheidet, ob 67 Mitglieder ein Testkonto in
 * ihrer Crew-Liste finden - und eine Zeile im Hook laesst sich nicht testen,
 * ohne den ganzen Hook samt Firebase zu mocken.
 *
 * @param {object}  viewer    das eigene Profil (`useAuth().profile`)
 * @param {boolean} explicit  Aufrufstelle verlangt Testdaten ausdruecklich
 *                            (Admin-Sicht auf Mitglieder bzw. der
 *                            Termin-Reiter im Admin-Bereich)
 */
export function maySeeTestData(viewer, explicit = false) {
  return explicit === true || isTestAccount(viewer);
}

/**
 * Die Mitglieder, die angezeigt werden duerfen.
 *
 * @param {Array}   members
 * @param {boolean} showTestData  true = Testkonten bleiben drin
 */
export function visibleMembers(members, showTestData = false) {
  const liste = Array.isArray(members) ? members : [];
  if (showTestData) return liste;
  return liste.filter((m) => !isTestAccount(m));
}

/**
 * Die Termine, die angezeigt werden duerfen.
 *
 * @param {Array}   events
 * @param {boolean} showTestData  true = Testtermine bleiben drin
 */
export function visibleEvents(events, showTestData = false) {
  const liste = Array.isArray(events) ? events : [];
  if (showTestData) return liste;
  return liste.filter((e) => !isTestEvent(e));
}
